import { useQuery } from '@apollo/client';
import { Spinner } from '../../../components';
import FetchError from '../../../components/generic/FetchError';
import { useSearchParams } from 'react-router-dom';
import { FETCH_LOCATION_SUPPLIERS_MAPPED } from '../queries/RiskHub';
import { Bar, BarConfig } from '@ant-design/plots';
import QueryErrorBoundary from '../../../components/error-handling';

const SuppliersMapped = () => {
  let [searchParams] = useSearchParams();

  const locationUuid = searchParams.get('location');

  const { data, loading, error } = useQuery(FETCH_LOCATION_SUPPLIERS_MAPPED, {
    variables: {
      filter: { locationUuid },
    },
  });

  const riskHubData = data?.suppliersMappedByLocation;
  const { addedSuppliers, totalSuppliers } = riskHubData || {};

  const simplifiedData = [
    {
      label: 'BCP Completed',
      type: 'Total',
      value: addedSuppliers + totalSuppliers,
    },
    {
      label: 'BCP Completed',
      type: 'Completed',
      value: addedSuppliers,
    },
  ];

  const simplifiedConfig: BarConfig = {
    data: simplifiedData,
    xField: 'value',
    yField: 'label',
    width: 250,
    yAxis: {
      label: null,
    },
    xAxis: false,
    appendPadding: 10,
    color: ['#CDCDCD', '#437EF7'],
    seriesField: 'type',
    barStyle: {
      radius: [30, 30, 0, 0],
    },
    legend: false,
    label: {
      position: 'right',
      offsetX: -6,
      layout: [{ type: 'interval-hide-overlap' }],
      content: (originData) => {
        // Show label only for the first item
        return originData.type === 'Completed' ? originData.value : '';
      },
      style: {
        fill: '#000', // Color of the label text
      },
    },
    barWidthRatio: 0.5,
    height: 50,
  };

  if (loading)
    return (
      <div className="flex items-center justify-center p-6">
        <Spinner />
      </div>
    );

  return (
    <>
      <QueryErrorBoundary error={error}>
        <div className="rounded-[10px] border border-secondary-100 overflow-hidden relative min-h-min">
          <h2 className="text-sm text-primary-100 tracking-wider font-bold border-b border-secondary-100 bg-silver flex justify-center items-center">
            SUPPLIERS MAPPED
          </h2>
          <div className="h-[200px] py-3 flex flex-col justify-between items-center">
            <span className="font-bold text-center text-5xl text-blue tracking-wider">
              {addedSuppliers + totalSuppliers || 0}
            </span>
            <Bar {...simplifiedConfig} />
            <div className="text-primary-100 text-xsm text-center font-light tracking-wider">
              BCP Added
            </div>
          </div>
        </div>
      </QueryErrorBoundary>
    </>
  );
};

export default SuppliersMapped;
